import React, { useState } from "react";
import AttachmentService from "../service/AttachmentService";
import { useNotification } from "../context/NotificationContext";
import ConfirmationModal from "./UI/ConfirmationModal";
import { FaTrash } from "react-icons/fa";
import { useDeleteAttachment } from "../data/useDeleteAttachment";
import LoadingSpinner from "./UI/LoadingSpinner";

export default function AttachmentView({ item, isEditing }) {
  const { addNotification } = useNotification();
  const { deleteAttachment, isDeleting } = useDeleteAttachment(item?.id);

  const [downloadingAttachmentId, setDownloadingAttachmentId] = useState(null);
  const [attachmentToDelete, setAttachmentToDelete] = useState(null);

  const handleDownloadAttachment = async (attachmentId, attachmentMime) => {
    setDownloadingAttachmentId(attachmentId);
    let url = "";
    try {
      const fileData = await AttachmentService.getAttachment(attachmentId);
      const blob = new Blob([fileData], {
        type: attachmentMime,
      });
      url = window.URL.createObjectURL(blob);
      window.open(url);
    } catch (error) {
      addNotification(error, "error");
      console.error("Error downloading attachment:", error);
    } finally {
      setDownloadingAttachmentId(null);
    }
  };

  const handleDeleteClick = (attachmentId) => {
    setAttachmentToDelete(attachmentId);
  };

  const handleCancelDelete = () => {
    setAttachmentToDelete(null);
  };

  const handleConfirmDelete = () => {
    deleteAttachment(attachmentToDelete);
    setAttachmentToDelete(null);
  };

  if (isDeleting) return <LoadingSpinner />;

  return (
    <>
      <span className="font-semibold">Attachments:</span>
      <ul className="mt-0 text-lg font-normal tracking-normal">
        {item?.attachments?.map((attachment, index) => (
          <li
            className="flex items-center gap-2 font-normal tracking-normal"
            key={attachment.id}
          >
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleDownloadAttachment(attachment.id, attachment.mime);
              }}
              className="text-blue-500"
            >
              {attachment.name}
            </button>
            {downloadingAttachmentId === attachment.id && (
              <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-stone-600 border-t-transparent"></div>
            )}
            {isEditing && (
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  handleDeleteClick(attachment.id);
                }}
                className="text-red-500"
              >
                <FaTrash /> {/* React icon for the trash can */}
              </button>
            )}
          </li>
        ))}
      </ul>

      <ConfirmationModal
        isOpen={!!attachmentToDelete}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        message={`Are you sure you want to delete this attachment?`}
      />
    </>
  );
}
